import React from 'react';
import Modal from '../../component/Inc/Modal';
function PopSetIdNumber(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} type="com_input">
      <>
        <h2 className="pop_tit">주민번호</h2>
        <p className="pop_desc com_red_txt">* 권한자만 볼 수 있습니다.</p>
        <div className="content_container scroll">
          <div className="com_input_wrap flex_row">
            <input type="text" className="input" />
            <span className="bar">-</span>
            <input type="text" className="input" />
          </div>
        </div>
        <div className="btn_container">
          <button className="com_btn orange xs">저장</button>
        </div>
      </>
    </Modal>
  );
}

export default PopSetIdNumber;
